import { ANGLE_LANDSCAPE, ASPECT_RATIO_LANDSCAPE, COLORS, TAN_LANDSCAPE } from './const'
import { getAspectRatioLandscape } from './App'
import TWEEN from '@tweenjs/tween.js'
import { MathUtils } from 'three'

const tan = Math.tan(MathUtils.degToRad(ANGLE_LANDSCAPE))
const tanNeg = Math.tan(MathUtils.degToRad(180 - ANGLE_LANDSCAPE))
const getTan = () => TAN_LANDSCAPE * getAspectRatioLandscape()
const getTanDouble = () => 1 + TAN_LANDSCAPE * getAspectRatioLandscape() * 2
const getTanNegDouble = () => -1 - TAN_LANDSCAPE * getAspectRatioLandscape() * 2
const { Cubic, Sinusoidal } = TWEEN.Easing

const KEYFRAMES_STRIPE_LANDSCAPE = {
	inForward: {
		duration: 750,
		delay: 750,
		left: () => [getTan() * -1, 0],
		top: () => [-1, 0],
		easing: Cubic.Out,
	},
	inBackward: {
		duration: 750,
		delay: 750,
		left: () => [getTan(), 0],
		top: () => [1, 0],
		easing: Cubic.Out,
	},
	outForward: {
		duration: 750,
		left: () => [0, getTan()],
		top: () => [0, 1],
		easing: Cubic.In,
	},
	outBackward: {
		duration: 750,
		left: () => [0, getTan()],
		top: () => [0, 1],
		easing: Cubic.In,
	},
}

export const SHAPES_LANDSCAPE = {
	mask: {
		sizing: 'fill',
		align: ['center', 'center'],
		skew: [tan, 0],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inForward: {
				duration: 1250,
				delay: 250,
				left: () => [getTanDouble(), 0],
				easing: Cubic.Out,
			},
			inBackward: {
				duration: 1250,
				delay: 250,
				left: () => [getTanNegDouble(), 0],
				easing: Cubic.Out,
			},
		},
	},
	maskStart: {
		sizing: 'fill',
		align: ['center', 'center'],
		skew: [tan, 0],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inBackward: {
				duration: 750,
				delay: 250,
				left: () => [getTanNegDouble(), 0],
				easing: Sinusoidal.Out,
			}
		},
	},
	maskStart2: {
		sizing: 'fill',
		align: ['center', 'top'],
		skew: [tan, 0],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inBackward: {
				duration: 750,
				delay: 750,
				left: () => [getTanNegDouble(), 0],
				easing: Sinusoidal.Out,
			},
			outBackward: {
				duration: 1500,
				left: () => [0, 0],
			},
		},
	},

	bigLeft: {
		anchor: [-0.675, 0],
		scale: [0.615, 1],
		skew: [tan, 0],
		align: ['left', 'center'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inForward: {
				duration: 1100,
				left: () => [-1, 0],
				easing: Cubic.Out,
			},
			inBackward: {
				duration: 1100,
				left: () => [-1, 0],
				easing: Cubic.Out,
			},
			outForward: {
				duration: 1100,
				left: () => [0, -1],
				easing: Cubic.In,
			},
			outBackward: {
				duration: 1100,
				left: () => [0, -1],
				easing: Cubic.In,
			},
		},
	},
	smallLeft: {
		anchor: [-2.65, 0],
		scale: [0.15, 1],
		skew: [tanNeg, 0],
		align: ['left', 'center'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inForward: {
				duration: 750,
				delay: 750,
				left: () => [-0.25, 0],
				easing: Cubic.Out,
			},
			inBackward: {
				duration: 750,
				delay: 750,
				left: () => [-0.25, 0],
				easing: Cubic.Out,
			},
			outForward: {
				duration: 375,
				left: () => [0, -0.25],
				easing: Cubic.In,
			},
			outBackward: {
				duration: 375,
				left: () => [0, -0.25],
				easing: Cubic.In,
			},
		},
	},
	bigRight: {
		scale: [0.65, 1],
		skew: [tanNeg, 0],
		align: ['right', 'center'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inForward: {
				duration: 750,
				delay: 750,
				left: () => [1, 0],
				easing: Cubic.Out,
			},
			inBackward: {
				duration: 750,
				delay: 750,
				left: () => [1, 0],
				easing: Cubic.Out,
			},
			outForward: {
				duration: 1125,
				left: () => [0, 1],
				easing: Cubic.In,
			},
			outBackward: {
				duration: 1125,
				left: () => [0, 1],
				easing: Cubic.In,
			},
		},
	},
	smallRight: {
		scale: [0.2, 1],
		align: ['right', 'center'],
		skew: [tan, 0],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: {
			inForward: {
				duration: 750,
				delay: 750,
				left: () => [0.25, 0],
				easing: Cubic.Out,
			},
			inBackward: {
				duration: 750,
				delay: 750,
				left: () => [0.25, 0],
				easing: Cubic.Out,
			},
			outForward: {
				duration: 375,
				left: () => [0, 0.25],
				easing: Cubic.In,
			},
			outBackward: {
				duration: 375,
				left: () => [0, 0.25],
				easing: Cubic.In,
			},
		},
	},
	stripeBlack: {
		anchor: [-0.45, 0],
		scale: [0.5, 1],
		skew: [tanNeg, 0],
		align: ['right', 'top'],
		sizing: 'height',
		color: COLORS.BLACK,
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: KEYFRAMES_STRIPE_LANDSCAPE,
	},
	stripeIntro: {
		anchor: [-0.25, 0],
		scale: [0.525, 1],
		skew: [tanNeg, 0],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		align: ['right', 'top'],
		keyframes: KEYFRAMES_STRIPE_LANDSCAPE,
	},
	stripeLeft: {
		anchor: [-0.25, 0],
		scale: [0.45, 1],
		skew: [tanNeg, 0],
		align: ['left', 'top'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: KEYFRAMES_STRIPE_LANDSCAPE,
	},
	stripeRight: {
		anchor: [-0.45, 0],
		scale: [0.415, 1],
		skew: [tanNeg, 0],
		align: ['right', 'top'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: KEYFRAMES_STRIPE_LANDSCAPE,
	},
	stripeContact: {
		anchor: [-1, 0],
		scale: [0.25, 1],
		skew: [tanNeg, 0],
		align: ['right', 'top'],
		baseAspect: ASPECT_RATIO_LANDSCAPE,
		keyframes: KEYFRAMES_STRIPE_LANDSCAPE,
	},
}
